import { Directive, inject } from '@angular/core';
import { IonInput } from '@ionic/angular';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'ion-input',
    standalone: false
})
export class IonicInputDirective {
  private readonly input = inject(IonInput);

  constructor() {
    this.input.labelPlacement = 'floating';
    this.input.fill = 'outline';
    this.input.mode = 'md';
  }
}
